import { GraphQLClient } from 'graphql-request'

export const gqlClient = (url: string, authorization: string) => {
  return new GraphQLClient(url, {
    headers: {
      authorization,
    },
  })
}
